import { usePageTitle } from '@/hooks/usePageTitle';
import { createFileRoute } from '@tanstack/react-router'
import { PortoutRequestHistory } from '@/features/dashboard/portout-request/history/PortoutRequestHistory';

export const Route = createFileRoute('/_dashboard/portout-requests/')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle("解約・転出依頼履歴");
  return <PortoutRequestHistory />
} 